"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditGridFilterButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../components/SimpleButton"));
const AdaptableContext_1 = require("../AdaptableContext");
const EditGridFilterButton = () => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const handleClick = React.useCallback((event) => {
        event.stopPropagation();
        adaptable.api.gridFilterApi.openUIEditorForGridFilter();
    }, []);
    return React.createElement(SimpleButton_1.default, { variant: "text", iconSize: 15, onClick: handleClick, icon: "edit" });
};
exports.EditGridFilterButton = EditGridFilterButton;
